import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TextField,
  Tooltip,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import Pagination from "@mui/lab/Pagination";
import * as actions from "../Releases/actions";
import CancelIcon from "@mui/icons-material/Cancel";
import _ from "lodash";
import AddBoxOutlined from "@mui/icons-material/AddBoxOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toastError, toastSuccess } from "../../utils";
import CustomShowModal from "../Common/customShowModal";

const CssTextField = styled(TextField)({
  fontFamily: "'DM Sans', sans-serif",
  color: "#fff",
  width: "100%",
  "& label": {
    fontFamily: "'DM Sans', sans-serif",
    color: "white",
  },
  "& label.Mui-focused": {
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "red",
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "#10baa8",
      borderWidth: "1px",
    },
  },
});

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default function Lyrics(props) {
  const [lyricsNew, setLyricsNew] = useState([]);
  const [pListPitchOld, setPListPitchOld] = useState([]);
  const [actionsModal, setActionsModal] = useState(false);
  const [detailsData, setDetailsData] = useState();
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [actionId, setActionId] = useState();
  const [count, setCount] = useState(0);

  const [filters, setFilters] = useState({
    limit: 50,
    offset: 0,
    page: 1,
    search: "",
  });

  const delaySearch = useCallback(
    _.debounce((filters) => onGetLyricsOld(filters), 500),
    []
  );

  useEffect(() => {
    onGetLyricsOld(filters);
    setTimeout(() => {
      props.setLoader(false);
    }, 5000);
  }, []);

  const onGetLyricsOld = (filters) => {
    props.setLoader(true);
    actions
      .getLyricsOldAdmin({ ...filters })
      .then((res) => {
        props.setLoader(false);
        setPListPitchOld(res.body);
        setCount(res.total);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Operation failed');
      });
  };

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    onGetLyricsOld(newFilters);
  };

  const onChangeSearch = (e) => {
    const newFilters = { ...filters, search: e.target.value };
    setFilters(newFilters);
    delaySearch(newFilters);
  };

  const onGetLyricsPitchNew = () => {
    props.setLoader(true);
    actions
      .getLyricsDestributionRequestAdmin()
      .then((res) => {
        setLyricsNew(res.body);
        props.setLoader(false);
        // setCount(res.total)
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to load lyrics distribution requests');
      });
  };

  useEffect(() => {
    onGetLyricsPitchNew();
  }, []);

  let totalPages = Math.ceil(Number(count) / filters.limit);

  const handleViewDetails = (data) => {
    setDetailsData(data);
    setViewDetailsModal(true);
  };

  const handleActionOnClick = (item) => {
    setActionsModal(true);
    setActionId(item);
  };

  const onConfirmAcceptModal = (status) => {
    props.setLoader(true);
    actions
      .updateLyricsStatusAdmin({ status: status, lyrics_id: actionId })
      .then((res) => {
        setActionsModal(false);
        onGetLyricsPitchNew();
        onGetLyricsOld(filters);
        toastSuccess(res.message || 'Lyrics status updated successfully');
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to update lyrics status');
      });
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <p style={{ fontWeight: 500 }}>Review Required</p>

          <Box mt={2}>
            <CssTextField
              type="text"
              variant="outlined"
              size="small"
              onChange={onChangeSearch}
              value={filters.search}
              placeholder="Search..."
            />
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TableContainer component={Paper}>
            <Table className="universal-table">
              <TableHead>
                <TableRow
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
                  }}
                >
                  <TableCell className="color-white">LId</TableCell>
                  <TableCell className="color-white">Name</TableCell>
                  <TableCell className="color-white">Email</TableCell>
                  <TableCell className="color-white">RId</TableCell>
                  <TableCell className="color-white">Release</TableCell>
                  <TableCell className="color-white">Audio</TableCell>
                  <TableCell className="color-white">View Details</TableCell>
                  <TableCell className="color-white">Date</TableCell>
                  <TableCell className="color-white">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {lyricsNew.length ? (
                  lyricsNew.map((item, key) => {
                    return (
                      <TableRow key={key}>
                        <TableCell>{item.lyrics_id}</TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{item.release_id}</TableCell>
                        <TableCell>{item.release_title}</TableCell>
                        <TableCell>{item.audio_title}</TableCell>
                        <TableCell>
                          <span
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              fontWeight: 500,
                            }}
                            onClick={() => handleViewDetails(item)}
                          >
                            View Lyrics
                          </span>
                        </TableCell>
                        <TableCell>{item.date}</TableCell>
                        <TableCell style={{ cursor: "pointer" }}>
                          <AddBoxOutlined
                            onClick={() => handleActionOnClick(item.lyrics_id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan="9" align="center">
                      No Requests Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item xs={12} style={{ marginTop: "20px" }}>
          <h2
            style={{
              fontWeight: 500,
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            Profile Linking History
          </h2>
          <TableContainer component={Paper}>
            <Table className="universal-table">
              <TableHead>
                <TableRow
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
                  }}
                >
                  <TableCell className="color-white">LId</TableCell>
                  <TableCell className="color-white">Name</TableCell>
                  <TableCell className="color-white">Email</TableCell>
                  <TableCell className="color-white">RId</TableCell>
                  <TableCell className="color-white">Release</TableCell>
                  <TableCell className="color-white">Audio</TableCell>
                  <TableCell className="color-white">View Details</TableCell>
                  <TableCell className="color-white">Date</TableCell>
                  <TableCell className="color-white">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pListPitchOld.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{item.lyrics_id}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.email}</TableCell>
                      <TableCell>{item.release_id}</TableCell>
                      <TableCell>{item.release_title}</TableCell>
                      <TableCell>{item.audio_title}</TableCell>
                      <TableCell>
                        <span
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                          onClick={() => handleViewDetails(item)}
                        >
                          View Lyrics
                        </span>
                      </TableCell>
                      <TableCell>{item.date}</TableCell>
                      <TableCell align="center">
                        <p onClick={(e) => e.stopPropagation()}>
                          {item.status === "rejected" ? (
                            <LightTooltip title="Rejected">
                              <CancelIcon style={{ color: "red" }} />
                            </LightTooltip>
                          ) : (
                            <LightTooltip title="Approved">
                              <CheckCircleIcon style={{ color: "green" }} />
                            </LightTooltip>
                          )}
                        </p>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <Pagination
              count={totalPages}
              showFirstButton
              showLastButton
              onChange={onPageChange}
              page={filters.page || 0}
            />
          </TableContainer>
        </Grid>
      </Grid>
      <CustomShowModal
        handleClose={() => setActionsModal(false)}
        title={"What's your action ?"}
        open={actionsModal}
        maxWidth="sm"
      >
        <div className="aceept-reject-button">
          <button
            className="accept"
            onClick={() => onConfirmAcceptModal("approved")}
          >
            Accept
          </button>
          <button
            className="reject"
            onClick={() => onConfirmAcceptModal("rejected")}
          >
            Reject
          </button>
        </div>
      </CustomShowModal>
      <CustomShowModal
        open={viewDetailsModal}
        handleClose={() => setViewDetailsModal(false)}
        maxWidth="sm"
        title={detailsData?.release_title || "Details"}
      >
        <div>
          <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
            <strong>Publishing rights:</strong>
            <br />
            {detailsData?.p_rights}
          </p>

          <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
            <strong>Lyrics Language:</strong>
            <br />
            {detailsData?.lyrics_language}
          </p>

          <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
            <strong>ISWC:</strong>
            <br />
            {detailsData?.iswc}
          </p>
          <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
            <a
              href={detailsData?.lrc_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Download LRC</strong>
            </a>
          </p>

          <p style={{ whiteSpace: "break-spaces", paddingBottom: "5px" }}>
            <strong>Lyrics:</strong>
            <br />
            {detailsData?.lyrics}
          </p>
        </div>
      </CustomShowModal>
    </div>
  );
}